export default "__VITE_ASSET__DqSPWYsJ__ 430w";